import Accordion from 'common/components/accordion'
import IconTitleGroup from 'common/components/iconTitleGroup'
import { useAppSelector } from 'common/hooks/redux'
import BriefCenterSection from 'features/unifiedFlow/contentPage/brief/centerSection/CenterSection'
import { getStepStatus } from 'features/unifiedFlow/contentPage/helpers'
import { useContent, useVariants } from 'features/unifiedFlow/contentPage/hooks'

type Props = {
  isWebsocketLoading: boolean
}

const BriefAccordion = ({ isWebsocketLoading }: Props) => {
  const { content } = useContent()

  const activeContentId = useAppSelector(
    (state) => state.unifiedFlow.activeContentId
  )
  const { data: variants } = useVariants(activeContentId, { withSubrows: true })

  const briefStepsStatus = getStepStatus(content?.steps_status, 'brief')

  const isBriefStepsStatusActive = briefStepsStatus === 'enabled' || 'active'

  if (!isBriefStepsStatusActive) {
    return null
  }

  const isOpen = isWebsocketLoading || variants?.length === 0

  return (
    <Accordion className="mb-6" data-testid="brief-accordion">
      <Accordion.Item
        isOpen={isOpen}
        title={
          <div className="flex items-center justify-between w-full">
            <IconTitleGroup title="Brief" />
          </div>
        }
      >
        <BriefCenterSection isWebsocketLoading={isWebsocketLoading} />
      </Accordion.Item>
    </Accordion>
  )
}

export default BriefAccordion
